/**
 * Location Form Modal Validation Schema
 * Zod schema for LocationFormModal
 */

import { z } from 'zod';

export const locationFormModalSchema = z.object({
  // Basic Information
  locationName: z
    .string()
    .min(1, 'vendor.validation.locationNameRequired')
    .max(100, 'vendor.validation.locationNameMax'),
  isDefaultReceiving: z.boolean(),

  // Address - using IDs for API submission
  country: z.string(), // Country code for display (kept for backward compatibility)
  countryId: z.number().nullable(), // Country ID for API submission
  stateId: z.number().nullable(),
  state: z.string(),
  cityId: z.number().nullable(),
  city: z.string(),
  postcode: z.string().min(1, 'vendor.validation.postcodeRequired'),
  address: z.string().min(1, 'vendor.validation.addressRequired'),
  addressLang: z.string().nullable().optional(), // Address language (en/zh)
  notes: z.string().optional().or(z.literal('')),
});

export type LocationFormModalData = z.infer<typeof locationFormModalSchema>;
